import { render, staticRenderFns } from "./PetmedClinicAttendancesDialog.vue?vue&type=template&id=7f3632b2&scoped=true&"
import script from "./PetmedClinicAttendancesDialog.vue?vue&type=script&lang=js&"
export * from "./PetmedClinicAttendancesDialog.vue?vue&type=script&lang=js&"
import style0 from "./PetmedClinicAttendancesDialog.vue?vue&type=style&index=0&id=7f3632b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3632b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VDataTable,VDialog,VIcon})
